import React from 'react';
import { DropzoneOptions, useDropzone } from 'react-dropzone';

export interface FileUploaderProps extends DropzoneOptions {
    id?: string;
    className?: string;
    acceptClassName?: string;
    rejectClassName?: string;
    activeClassName?: string;
    disabledClassName?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
    required?: boolean;
}
export interface ImageFile extends File {
    preview?: string;
}

export const setPreview = (file: Blob | MediaSource) => {
    return Object.assign(file, { preview: URL.createObjectURL(file) });
};

const FileUploader: React.FC<FileUploaderProps> = (props) => {
    const { className, acceptClassName, activeClassName, rejectClassName, id, required, ...rest } = props;
    const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({ ...rest });
    let buttonClassName = className;
    if (isDragReject && rejectClassName) {
        buttonClassName = rejectClassName;
    } else if (isDragAccept && acceptClassName) {
        buttonClassName = acceptClassName;
    } else if (isDragActive && activeClassName) {
        buttonClassName = activeClassName;
    }
    return (
        <div {...getRootProps({ className: 'drop-areax' })}>
            <input data-testid="fileUploader-input" {...getInputProps()} required={required} />
            <button type="button" id={id} className={buttonClassName}>
                {props.children}
            </button>
        </div>
    );
};

export default FileUploader;
